import * as z from "zod/v4";
import { PropertyFilterSchema } from "./property-filter.js";

const IntegrationFilterV2Schema_ = z.object({
  id: z.string(),
  integrationId: z.string(),
  merchantId: z.string(),
  eventName: z.string(),
  propertyFilters: z.array(PropertyFilterSchema),
  createdAt: z.string(),
  updatedAt: z.string(),
  isEnabled: z.boolean(),
});
export const IntegrationFilterV2Schema: z.ZodType<IntegrationFilterV2> =
  IntegrationFilterV2Schema_;
export interface IntegrationFilterV2
  extends z.infer<typeof IntegrationFilterV2Schema_> {}
